<template>
  <div>
    <el-container>
      <top-bar @logOut="logOut" />
    </el-container>

    <el-container>
      <el-aside v-if="$store.state.user.id">
        <side-nav :permittedModules="permittedModules[$route.name]" />
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import _ from "lodash";
import jwt from "jsonwebtoken";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    TopBar: () => import("@/components/parts/TopBar"),
    SideNav: () => import("@/components/parts/SideNav")
  },
  computed: {
    ...mapState(["user", "company"])
  },
  watch: {
    $route(to, from) {
      this.configureSession();
    }
  },
  methods: {
    verifyToken(token) {
      try {
        return jwt.verify(token, process.env.VUE_APP_JWT_TOKEN);
      } catch (err) {
        console.log(err);
        // this.logOut();
      }
    },
    getJWT() {
      return this.verifyToken(this.$session.get("user"));
    },
    configureSession() {
      if (this.$session.exists() && this.getJWT("user").data) {
        // console.log('logged in');

        const jwtUser = this.getJWT("user").data;

        if (!_.isEmpty(jwtUser)) {
          if (_.isEmpty(this.user) || this.user.email == undefined)
            this.$store.commit({ type: "setUser", user: jwtUser });

          if (
            (_.isEmpty(this.company) || this.company.name == undefined) &&
            !_.isEmpty(jwtUser.Company)
          ) {
            this.$store.commit({
              type: "setCompany",
              company: jwtUser.Company[0]
            });
          }
        }

        // if (initial) console.log(this.user);
      } else {
        this.logOut();
      }
    },
    logOut() {
      this.$router.push("/login");
      // this.loggingOut = true;

      if (this.$session.exists()) {
        this.$session.destroy();

        if (!_.isEmpty(this.user))
          this.$store.commit({ type: "setUser", user: {} });
        if (!_.isEmpty(this.company)) console.log("set company");
        this.$store.commit({ type: "setCompany", company: {} });
      }
    }
  },
  data() {
    return {
      permittedModules: {
        "my-dashboard": [
          "tickets-purchased",
          "resource-downloads",
          "monthly-newsletters"
        ],
        "company-dashboard": [
          "member-communications",
          "about",
          "billing",
          "members",
          "innovator-award-winners",
          "your-company-committees"
        ]
      }
    };
  }
};
</script>
